
import { defineComponent, computed, onMounted } from "vue";
import CommonRecipeList from "@/components/commonRecipe/CommonRecipeList.vue";
import CommonDialog from "@/components/common/CommonDialog.vue";
import { useApiErrorHandler } from "@/use/use-api-error-handler";
import { useApiErrorDialog } from "@/use/use-api-error-dialog";
import store from "@/store";
import router from "@/router";
import { PAGE_ID } from "@/const/log-const";
import { SEARCH_RECIPE_TYPE } from "@/types/search";
import NativeClient, { TitleInfo } from "@/client/native-client";
import { createRecipeToCommonRecipes } from "@/utils/search-util";
import CommonUtil from "@/utils/common-utils";
import { BeaconLogInfo } from "@/types/common";

export default defineComponent({
  name: "SearchRecommendPage",
  components: { CommonRecipeList, CommonDialog },
  setup() {
    const limitCount = -1;
    NativeClient.setTitle(new TitleInfo(false, ""));
    CommonUtil.scroll({ top: 0, left: 0 });

    // urlから選択されたtypeを取得
    const recipeType = String(router.currentRoute.value.query.type);

    /** APIリクエスト時のエラーハンドル */
    const {
      handleApiError,
      getApiErrorTitle,
      getApiErrorMessage
    } = useApiErrorHandler();

    /** ダイアログの制御 */
    const { closeDialog } = useApiErrorDialog();

    /**
     * レシピリストを取得する
     */
    const getRecipes = async () => {
      store.dispatch("common/startLoading");
      await NativeClient.getApiParams();
      switch (recipeType) {
        case SEARCH_RECIPE_TYPE.RANKING:
          store.dispatch("search/getRankingRecipes");
          break;
      }
      store.dispatch("common/stopLoading");
    };

    /**
     * レシピリストの取得を実行する
     */
    const execute = async () => {
      getRecipes();
    };

    /**
     * コンポーネントがマウントされたときに通知される
     */
    onMounted(() => {
      const beaconLogInfo = new BeaconLogInfo(PAGE_ID.RECIPE_RANKING, null, new Array<string>());
      NativeClient.sendViewedLog(beaconLogInfo);
      execute();
    });

    /**
     * レシピ種別からレシピリスト取得(TODO)
     */
    const getRecipe = () => {
      let recipes = null;
      switch (recipeType) {
        case SEARCH_RECIPE_TYPE.RANKING:
          recipes = store.getters["search/getRankingRecipes"];
          break;
      }
      let commonRecipe = null;
      if (recipes != null) {
        commonRecipe = createRecipeToCommonRecipes(recipes.recipes);
      }
      return commonRecipe;
    };

    /**
     * レシピリスト取得
     */
    const recommendRecipes = computed(() => {
      const result = getRecipe();
      if (result != null) {
        NativeClient.sendDebugLog(
          "RecommendPage computed recommendRecipes no empty"
        );
        return result;
      }
      NativeClient.sendDebugLog(
        "RecommendPage computed recommendRecipes empty"
      );
      return null;
    });

    /**
     * レシピ種別からタイトルを取得
     */
    const getTitle = () => {
      switch (recipeType) {
        case SEARCH_RECIPE_TYPE.RANKING:
          return "人気レシピ";
      }
      return "";
    };

    /**
     * 選択されたレシピをNativeに通知する
     */
    const selectRecipe = (id: number, type: string) => {
      // Native側にレシピ詳細画面に遷移指示を出す
      NativeClient.sendDebugLog(
        "RecommendPage selectRecipe id=" + id + " type=" + type
      );
      NativeClient.transitionReceipDetail(id, type);
    };

    /**
     * レシピ取得APIの呼び出しをリトライする
     */
    const retryGetRecipes = () => {
      // ダイアログを閉じる
      closeDialog();
      getRecipes();
    };

    return {
      recommendRecipes,
      limitCount,
      selectRecipe,
      recipeType,
      getTitle,
      retryGetRecipes,
      handleApiError,
      getApiErrorTitle,
      getApiErrorMessage,
      closeDialog
    };
  }
});
